import { Injectable } from "@angular/core";
import { Development } from "@models/development.model";
import BaseService from "./base.service";

/**
 * A variant of the BaseService where the Development's information is stored.
 *
 * @class DevelopmentService
 * @augments {BaseService<Development>}
 */
@Injectable({
  providedIn: "root",
})
export class DevelopmentService extends BaseService<Development> {
  getAllowedDevelopments(): number[] {
    return this.getItems()
      .filter((d) => d.includeExclude.toLocaleLowerCase() === "include")
      .map((d) => d.id);
  }
}
